import {useUser} from '@gaia/stores/user';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {MapboxControlButton, MapboxControlGroup} from '@gaia/utils/mapbox/MapboxControl';
import SubscriptionTooltip from '@map/SubscriptionTooltip';
import {useCallback} from 'react';

interface ThreeDControlProps {
    is3D: boolean;
    map: mapboxgl.Map;
    setIs3D: SetState<boolean>;
    userLayers: UserLayer[] | undefined;
}

// Triggers use3D effect
export default function Toggle3D({is3D, map, setIs3D, userLayers}: ThreeDControlProps) {
    const toggle3D = useCallback(() => {
        const visibleLayers = userLayers?.filter((l) => l.isVisible).map((l) => l.layer);
        setIs3D((current) => {
            if (!current)
                ampli.press3DButton({
                    category: 'map2',
                    rotation: map.getBearing(),
                    sources: visibleLayers ?? [],
                    zoom: map.getZoom(),
                });
            return !current;
        });
    }, [map, setIs3D, userLayers]);

    const title = is3D ? 'Toggle 2D' : 'Toggle 3D';

    // 3D mode is only available to authenticated users and leet hackers
    const isDisabled = !useUser().isAuthenticated;

    return (
        <MapboxControlGroup>
            <MapboxControlButton aria-label={title} onClick={toggle3D} disabled={isDisabled}>
                <SubscriptionTooltip
                    enterDelay={500}
                    placement='right'
                    title={title}
                    subscription='user'
                    analyticsContext='3D'
                >
                    <span>{is3D ? '2D' : '3D'}</span>
                </SubscriptionTooltip>
            </MapboxControlButton>
        </MapboxControlGroup>
    );
}
